import { Button, FlexBox, Icon, Link, Typography } from '@vp/swan';
import { DS_BRIEF_CREATE_URL, __, getCareBriefCreateURL } from '@99designs/i18n';
import { sendNavigationEvent, usePage } from '@99designs/tracking';

export const CreateAProjectCTA = () => {
    const { pageData } = usePage();
    const pageZone = 'Design Category Tiles';
    const ctaValue = 'CreateAProject-CTA';
    const onClickTracking = () => {
        sendNavigationEvent({
            label: `Content: ${pageZone}`,
            eventDetail: `${
                pageData.pagePath || window.location.pathname
            };${DS_BRIEF_CREATE_URL}/care-design;${pageZone};${ctaValue}`,
            navigationDetail: ctaValue,
            ...pageData,
        });
    };
    return (
        <FlexBox alignItems="center" gap="5" flexDirection={{ xs: 'column', sm: 'row' }}>
            <Typography>
                {__('Can’t find the design service you are looking for?', {
                    _context:
                        'message displayed next to "Create a project" button that prompts users who can’t find the design service they are looking for to create a new project',
                })}
            </Typography>
            <Button
                skin="secondary"
                render={(props) => (
                    <Link
                        to={getCareBriefCreateURL()}
                        className={props.className}
                        onClick={onClickTracking}
                    >
                        {props.children}
                    </Link>
                )}
            >
                {__('Create a project', {
                    _context: 'button that prompts users to create a new project',
                })}
                <Icon iconType="arrowRight" />
            </Button>
        </FlexBox>
    );
};
